import { useCallback } from 'react'
import { useErrorModal } from '../../../hooks/api/use-error-modal'
import { useSetShipmentToolingInclusionMutation } from '../../../store/api/shipments-api'
import Shipment from '../../../types/api/shipment'
import { EndpointQueryParameters } from '../../../types/strapi/strapi'
import { ToolingKind } from '../helpers/tooling-inclusion'
import { useUpdateQueryData } from './use-update-query-data'

/** Включение/исключение оснастки (штамп, формы) в расчёт отгрузки */
export function useSetToolingIncluded(queryArg: EndpointQueryParameters) {
    const [setShipmentToolingInclusion, state] = useSetShipmentToolingInclusionMutation()
    const updateQueryData = useUpdateQueryData(queryArg)

    useErrorModal(state, 'Не удалось изменить включение оснастки')

    return useCallback(
        async (record: Shipment, kind: ToolingKind, included: boolean) => {
            const res = await setShipmentToolingInclusion({
                docId: record.documentId,
                kind,
                included,
                queryParams: queryArg,
            })

            if (res.data) {
                updateQueryData(res.data.data)
            }
        },
        [setShipmentToolingInclusion, queryArg, updateQueryData]
    )
}
